import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "el-tree-select",
  props: {
    // 配置项
    props: {
      type: Object,
      default: {
        value: 'id',
        // ID字段名
        label: 'title',
        // 显示名称
        children: 'children' // 子级字段名

      }
    },
    // 选项列表数据(树形结构的对象数组)
    options: {
      type: Array,
      default: []
    },
    // 初始值
    value: {
      type: String,
      default: null
    },
    // 可清空选项
    clearable: {
      type: Boolean,
      default: true
    },
    // 自动收起
    accordion: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      valueId: null,
      valueTitle: '',
      defaultExpandedKey: []
    };
  },
  mounted: function mounted() {
    this.valueId = this.value, // 初始值
    this.initHandle();
  },
  methods: {
    // 初始化值
    initHandle: function initHandle() {
      if (this.valueId) {
        this.valueTitle = this.$refs.selectTree.getNode(this.valueId).data[this.props.label]; // 初始化显示

        this.$refs.selectTree.setCurrentKey(this.valueId); // 设置默认选中

        this.defaultExpandedKey = [this.valueId]; // 设置默认展开
      }

      this.initScroll();
    },
    // 初始化滚动条
    initScroll: function initScroll() {
      this.$nextTick(function () {
        var scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0];
        var scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar');
        scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;';
        scrollBar.forEach(function (ele) {
          return ele.style.width = 0;
        });
      });
    },
    // 切换选项
    handleNodeClick: function handleNodeClick(node) {
      this.valueTitle = node[this.props.label];
      this.valueId = node[this.props.value];
      this.$emit('getValue', this.valueId);
      this.defaultExpandedKey = [];
    },
    // 清除选中
    clearHandle: function clearHandle() {
      this.valueTitle = '';
      this.valueId = null;
      this.defaultExpandedKey = [];
      this.clearSelected();
      this.$emit('getValue', null);
    },
    // 清空选中样式
    clearSelected: function clearSelected() {
      var allNode = document.querySelectorAll('#tree-option .el-tree-node');
      allNode.forEach(function (element) {
        return element.classList.remove('is-current');
      });
    }
  },
  watch: {
    value: function value() {
      this.valueId = this.value;
      this.initHandle();
    }
  }
};